import { Nullable } from "common/records";
import { OrgRecord } from "common/records/Org";
import { getFullName, UserRecord } from "common/records/User";

/**
 * Sets up the LiveChatWidget with context data on user & org.
 * Should only ever be called with both but can handle nulls.
 * Catches anything to do with LiveChatWidget that might throw an error.
 *
 * @param user Nullable<UserRecord> - The current user record.
 * @param org Nullable<OrgRecord> - The current users org record
 * @returns
 */
export const setupUser = (user: Nullable<UserRecord>, org: Nullable<OrgRecord>) => {
  const LiveChatWidget = (window as any).LiveChatWidget;
  if (!LiveChatWidget) return;

  // catching anything from LiveChatWidget that might throw an error
  try {
    if (user) {
      LiveChatWidget.call("set_customer_name", getFullName(user));
      LiveChatWidget.call("set_customer_email", user.email);
    }

    LiveChatWidget.call("set_session_variables", {
      userId: user?.id,
      orgId: org?.id,
      orgName: org?.name,
    });
  } catch (error) {
    console.error("Error setting up LiveChatWidget:", error);
  }
};
